


































import { defineComponent } from "@vue/composition-api";
import OccButton from "@/components/Atoms/OccButton/index.vue";

export interface Props {
  type: string;
  label: string;
  status: string;
  size: string;
  active: boolean;
  bold: boolean;
  deleteButton: boolean;
}

export default defineComponent({
  name: "OccTag",
  components: {
    OccButton
  },
  props: {
    type: {
      type: String,
      default: "circle",
      validator(type: string) {
        return ["circle", "square", "dot", "badge"].includes(type);
      }
    },
    label: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary",
      validator(type: string) {
        return [
          "bar-teal",
          "bar-blue",
          "bar-olive",
          "primary",
          "alert"
        ].includes(type);
      }
    },
    align: {
      type: String,
      default: "",
      validator(type: string) {
        return ["", "left", "right"].includes(type);
      }
    },
    size: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    deleteButton: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click", "delete"],
  setup(_props: Props, context: any) {
    const deleteEvent = () => {
      context.emit("delete");
    };

    return { deleteEvent };
  }
});
